import React, { useState } from 'react';
import { getOverallStatistics } from '../Services/Search.services';
import Stats from '../Components/Shared/Stats';
import { getDateOneMonthAgo, transformOverallStatisticsData } from '../Utils/Utils';
import { format } from 'date-fns';
import { dateFormat } from '../Constants/Date.constant';
import { Header } from '../Components/Shared/Header/Header';
import SkeletonComponent from '../Components/SkeletonComponent';
import { fieldNames, Filters } from '../Components/Shared/Filters/Filters';
import { Alert, Card, CardContent, Grid, Stack } from '@mui/material';
import Paper from '@mui/material/Paper';

function OverallStatistics() {
    const initialDateFilterValues = {
        [fieldNames.startDate]: getDateOneMonthAgo(),
        [fieldNames.endDate]: new Date(),
    };
    const [isGroupedByOrg, setIsGroupedByOrg] = useState(false);
    const [tableData, setTableData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [excludeOrganisations, setExcludeOrganisations] = useState(['avail.ai']);

    const setFilterFormValue = (filterValues, isCleared) => {
        const excludedOrganizations = filterValues.excludeLines;
        const startDate = filterValues.startDate;
        const endDate = filterValues.endDate;
        const formattedStartDate = startDate && format(startDate, dateFormat);
        const formattedEndDate = endDate && format(endDate, dateFormat);
        const checkboxValue = filterValues.checkbox;

        setExcludeOrganisations(excludedOrganizations);
        setIsGroupedByOrg(checkboxValue);

        if (isCleared) {
            setTableData({});
        } else {
            getRecords(formattedStartDate, formattedEndDate, excludedOrganizations, checkboxValue);
        }
    };

    const getRecords = (startDate, endDate, excludeOrganisations, isGroupedByOrg) => {
        setIsLoading(true);
        const urlParam = makeParams(startDate, endDate, excludeOrganisations, isGroupedByOrg);

        getOverallStatistics(urlParam)
            .then((data) => {
                if (!data) return;

                const statsData = transformOverallStatisticsData(data, isGroupedByOrg);
                setTableData(statsData);
                setIsLoading(false);
            });
    };

    const makeParams = (startDate, endDate, excludeOrganisations, isGroupedByOrg) => {
        const params = new URLSearchParams();

        if (startDate) {
            params.append('startDate', startDate);
        }

        if (endDate) {
            params.append('endDate', endDate);
        }

        if (excludeOrganisations) {
            if (Array.isArray(excludeOrganisations)) {
                excludeOrganisations.forEach((org) => params.append('exclude_organisation', org));
            } else {
                params.append('excludeOrganisations', excludeOrganisations);
            }
        }

        params.append('group_by_organisation', isGroupedByOrg);

        return '?' + params.toString();
    };

    return (
        <Grid item xs={12} sm={12} md={12} sx={{ mt: 2, mb: 2 }}>
            <Card component={Paper}>
                <CardContent>
                    <div className="header">
                        <Header
                            title="Overall Statistics"
                            filters={(
                                <Filters
                                    isDateRange
                                    isExcludeLines
                                    isCheckbox
                                    onFiltersChange={setFilterFormValue}
                                    initialValues={{
                                        [fieldNames.excludeLines]: excludeOrganisations,
                                        ...initialDateFilterValues,
                                    }}
                                    initialFieldOptions={{ checkbox: { label: 'Group by organisation' } }}
                                />
                            )}
                        />
                    </div>
                    {
                        isLoading
                            ? <SkeletonComponent />
                            : tableData?.length
                                ? (
                                    <Stats
                                        data={tableData}
                                        isGroupedByOrg={isGroupedByOrg}
                                    />
                                )
                                : (
                                    <Stack sx={{ width: '100%' }} spacing={2}>
                                        <Alert severity="warning">
                                            No auto loading of records. Configure and apply filters to
                                            load records
                                        </Alert>
                                    </Stack>
                                )
                    }
                </CardContent>
            </Card>
        </Grid>
    );
}

OverallStatistics.propTypes = {};
export default OverallStatistics;
